module.exports = __webpack_public_path__ + "fonts/Baewatch.6a1d8aeb.woff2";